var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showBanner)?_c('VerifyEmailBanner',{attrs:{"userCreationTime":_vm.userCreationTime}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }